import gql from 'graphql-tag';

export const CREATE_ARTICLE_CATEGORY_MUTATION = gql`
  mutation CreateArticleCategoryMutation($campaignId: ID!, $input: CampaignArticleCategoryInput!) {
    createArticleCategory(campaignId: $campaignId, input: $input) {
      articleCategory {
        id
        name
        description
        isDefault
        createdAt
      }
      errors
    }
  }
`;
